import * as signalR from '@microsoft/signalr';
import dayjs from 'dayjs';
import api, { setTokens } from './apiHelper'; // adjust import based on your project
import { SERVER_URL } from '../constants';
// import { setTokens } from './authUtils'; // adjust import based on your project

class ChatService {
    constructor() {
        const accessToken = localStorage.getItem("accessToken");

        this.connection = new signalR.HubConnectionBuilder()
            .withUrl(SERVER_URL + "hub", {
                accessTokenFactory: async () => await this.getToken()
            })
            .withAutomaticReconnect()
            .configureLogging(signalR.LogLevel.Information)
            .build();

        this.isConnected = false;
        this.isMessageListenerRegistered = false;
        this.callBacks = [];
        this.audio = new Audio('/newMessage.wav');
    }

    static getInstance() {
        if (!ChatService.instance) {
            ChatService.instance = new ChatService();
        }
        return ChatService.instance;
    }

    async getToken() {
        const accessToken = localStorage.getItem("accessToken");
        if (this.isTokenExpired() || accessToken === "") {
            const newAccessToken = await this.refreshAccessToken();
            return newAccessToken;
        }
        return accessToken || "";
    }

    isTokenExpired() {
        const tokenExpiryString = localStorage.getItem("refreshTokenExpiry");
        if (tokenExpiryString) {
            const expiry = dayjs(tokenExpiryString);
            return !(dayjs() < expiry);
        }
        return true;
    }

    async startConnection(callBack) {
        if (this.connection.state === signalR.HubConnectionState.Connecting) {
            this.callBacks.push(callBack);
            return;
        } else if (this.connection.state === signalR.HubConnectionState.Connected) {
            this.callBacks.forEach(call => call());
            this.callBacks = [];
            callBack();
            return;
        } else {
            try {
                await this.connection.start();
                this.isConnected = true;
                this.callBacks.forEach(call => call());
                this.callBacks = [];
                callBack();
            } catch (err) {
                setTimeout(() => this.startConnection(callBack), 5000);
            }
        }
    }

    async stopConnection() {
        if (this.connection.state === signalR.HubConnectionState.Connected) {
            try {
                await this.connection.stop();
                this.isConnected = false;
            } catch (err) {
                console.error("SignalR Disconnection Error: ", err);
            }
        }
    }

    playSound() {
        this.audio.play().catch(error => console.error("Audio play error: ", error));
    }



    async bindOnNewMessage(callBack) {
        this.connection.on("Alert", (message, timeStamp) => {
            callBack(message, timeStamp);
        });
    }

   

    async sendAlert(message, callBack) {
        try {
            const resp = await this.connection.invoke("SendAlert", message);
            callBack(resp);
        } catch (err) {
            console.log("jlksahdlkjashda",err)
            // handle error
        }
    }


    async refreshAccessToken() {
        try {
            const refreshToken = localStorage.getItem("refreshToken");
            const response = await api().post("auth/refresh", { refreshToken: refreshToken });

            if (response.status === 200) {
                const { accessToken: newAccessToken, refreshToken: newRefreshToken, expiresIn: expiry } = response.data;
                setTokens(newAccessToken, newRefreshToken, expiry);
                return newAccessToken;
            } else {
                throw new Error("Failed to refresh token");
            }
        } catch (error) {
            throw error;
        }
    }
}

// Export singleton instance
const chatService = ChatService.getInstance();
export default chatService;
